import React from 'react';
import './PolicyPages.css';

const PrivacyPolicyPage = () => {
  return (
    <div className="policy-page-container">
      <div className="policy-content">
        <h1 className="policy-title">Privacy Policy – House of Microgreens</h1>
        <p className="policy-updated">Last updated: 25 November 2025</p>
        
        <p className="policy-intro">
          Your privacy is important to us. This policy explains how we collect, use, and protect your information.
        </p>

        <section className="policy-section">
          <h2>1. Information We Collect</h2>
          <p>We may collect the following information when you use our website or place an order:</p>
          <ul>
            <li>Name</li>
            <li>Mobile number</li>
            <li>Email address</li>
            <li>Delivery address and PIN code</li>
            <li>Order and subscription details</li>
            <li>Payment confirmation details from Razorpay (no card/UPI numbers stored)</li>
            <li>Photos/videos shared for support (quality issues, replacements)</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>2. How We Use Your Information</h2>
          <p>We use your data to:</p>
          <ul>
            <li>Process orders and subscriptions</li>
            <li>Schedule deliveries</li>
            <li>Communicate updates (order confirmation, delays, offers, etc.)</li>
            <li>Improve our website and services</li>
            <li>Comply with legal requirements</li>
          </ul>
          <p>We may send occasional promotional messages. You can request opt-out anytime.</p>
        </section>

        <section className="policy-section">
          <h2>3. Sharing of Information</h2>
          <p>We do not sell your data.</p>
          <p>We may share limited data with:</p>
          <ul>
            <li>Delivery partners</li>
            <li>Payment gateway providers (Razorpay)</li>
            <li>Technical/IT service providers bound by confidentiality</li>
            <li>Authorities if legally required</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Cookies</h2>
          <p>We use cookies to:</p>
          <ul>
            <li>Improve website experience</li>
            <li>Remember preferences</li>
            <li>Analyze traffic</li>
          </ul>
          <p>You can disable cookies in your browser settings.</p>
        </section>

        <section className="policy-section">
          <h2>5. Data Security</h2>
          <p>We use reasonable measures to safeguard your information. However, no method is 100% secure.</p>
        </section>

        <section className="policy-section">
          <h2>6. User Rights</h2>
          <p>You may request:</p>
          <ul>
            <li>To update your information</li>
            <li>To delete your information (except when required for compliance/reporting)</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>7. Changes to Privacy Policy</h2>
          <p>Changes will be updated on this page with a new "Last updated" date.</p>
        </section>

        <section className="policy-section">
          <h2>8. Contact</h2>
          <p><strong>Email:</strong> hi@houseofmicrogreens.in</p>
          <p><strong>Phone/WhatsApp:</strong> +916363312348</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
